var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinTaperOnStateChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 5.8203 5.8203 0 13 0V0C20.1797 0 26 5.8203 26 13V13C26 20.1797 20.1797 26 13 26V26C5.8203 26 0 20.1797 0 13V13Z",
    fill: "#3BDC65",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 4.33276C9.51561 4.33276 6.69727 7.04543 6.69727 10.3994C6.69727 14.9494 13.0003 21.6661 13.0003 21.6661C13.0003 21.6661 19.3033 14.9494 19.3033 10.3994C19.3033 7.04543 16.4849 4.33276 13.0003 4.33276Z",
    fill: "#3BDC65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6768 22.9079L13.0001 21.666L14.3235 22.9079L13.0001 24.3181L11.6768 22.9079ZM14.1995 20.289C16.028 18.0848 19.3032 13.6791 19.3032 10.3993C19.3032 7.04531 16.4848 4.33264 13.0001 4.33264C9.51548 4.33264 6.69714 7.04531 6.69714 10.3993C6.69714 13.6791 9.97226 18.0848 11.8008 20.289C12.509 21.1426 13.0001 21.666 13.0001 21.666C11.6768 22.9079 11.6768 22.9079 11.6768 22.9079L11.674 22.9049L11.6689 22.8994L11.652 22.8813L11.5922 22.8165C11.5413 22.761 11.4685 22.681 11.3771 22.5789C11.1943 22.3746 10.9362 22.0809 10.6279 21.7153C10.0129 20.986 9.18968 19.9605 8.36257 18.7806C7.53924 17.6061 6.68802 16.2445 6.03666 14.8451C5.39704 13.4709 4.88232 11.9182 4.88232 10.3993C4.88232 5.97827 8.57918 2.51782 13.0001 2.51782C17.4211 2.51782 21.118 5.97827 21.118 10.3993C21.118 11.9182 20.6032 13.4709 19.9636 14.8451C19.3123 16.2445 18.461 17.6061 17.6377 18.7806C16.8106 19.9605 15.9874 20.986 15.3724 21.7153C15.0641 22.0809 14.806 22.3746 14.6232 22.5789C14.5318 22.681 14.459 22.761 14.408 22.8165L14.3483 22.8813L14.3314 22.8994L14.3263 22.9049L14.3246 22.9067C14.3246 22.9067 14.3235 22.9079 13.0001 21.666C13.0001 21.666 13.4913 21.1426 14.1995 20.289Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4651 17.3811L10.5229 17.4083L12.0056 14.1135H13.9825L15.4651 17.3811Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9945,
    cy: 9.99472,
    r: 2.79477,
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.823693,
    transform: "matrix(-1 0 0 1 12.9947 9.99484)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7929_29255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4165 5.50008C16.4165 3.24622 18.246 1.41675 20.4998 1.41675C22.7537 1.41675 24.5832 3.24622 24.5832 5.50008C24.5832 7.75394 22.7537 9.58342 20.4998 9.58342C18.246 9.58342 16.4165 7.75394 16.4165 5.50008Z",
    fill: "white",
    stroke: "#354052"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7929_29255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0693 5.46067C16.0693 3.03814 18.0357 1.07178 20.4582 1.07178C22.8807 1.07178 24.8471 3.03814 24.8471 5.46067C24.8471 7.88319 22.8807 9.84955 20.4582 9.84955C18.0357 9.84955 16.0693 7.88319 16.0693 5.46067Z",
    fill: "white",
    stroke: "#354052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4582 0.571777C17.7596 0.571777 15.5693 2.762 15.5693 5.46067C15.5693 8.15933 17.7596 10.3496 20.4582 10.3496C23.1569 10.3496 25.3471 8.15933 25.3471 5.46067C25.3471 2.762 23.1569 0.571777 20.4582 0.571777ZM19.4804 7.90511L17.036 5.46067L17.7253 4.77133L19.4804 6.52155L23.1911 2.81089L23.8804 3.50511L19.4804 7.90511Z",
    fill: "#354052"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7929_29255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(15)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7929_29255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.7333,
    height: 11.7333,
    fill: "white",
    transform: "translate(14.5918 -0.406006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinTaperOnStateChecked1);
export default __webpack_public_path__ + "static/media/Pin-Taper-On State-Checked-1.44b36a281e44ce1ce0a0bee15ff5c2ce.svg";
export { ForwardRef as ReactComponent };